import { render, staticRenderFns } from "./Langzeitpflege.vue?vue&type=template&id=0d663c12&"
import script from "./Langzeitpflege.vue?vue&type=script&lang=js&"
export * from "./Langzeitpflege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports